import React, { Component } from 'react'
import SearchBarStyles from '../styles/components/search-bar'
import DropDownStyles from '../styles/components/dropdown'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import { searchDetails } from '../redux/actions/benefitDetailsActions'
import { localize, getFullLocale } from '../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Tooltip from '../controls/Tooltip'
import Icon from '@material-ui/core/Icon'
import { Colors } from '../theme'

class RBSearchBar extends Component {
  constructor () {
    super()
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      search: ''
    }
  }

  handleChange (event, value) {
    this.setState({ search: event.target.value })
    this.props.searchDetails(event.target.value)
  }

  render () {
    let local = getFullLocale()

    const { classes = {} } = this.props

    const adornment = <div style={{ display: 'flex' }}>
      <IconButton className={classes.button} disabled={this.props.isDisabled} onClick={this.handleChange} id='searchIcon'>
        <Icon className={classes.searchIcon} color='primary'>search</Icon>
      </IconButton>
      <Tooltip title={localize('pages.Member.searchTooltip')} placement="right-end">
        <IconButton className={this.props.classes.button} >
          <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
        </IconButton>
      </Tooltip>
    </div>

    return (
      <div>
        <label>{localize('pages.Member.search')}</label>
        <br />
        <TextField
          ref={(input) => { this.search = input }}
          className={local === 'en-CA' ? classes.baseDropdown : classes.searchBarInput}
          helperText={localize('pages.Member.searchHint')}
          onChange={this.handleChange}
          disabled={this.props.isDisabled}
          InputProps={{
            endAdornment: adornment
          }}
        />

      </div>
    )
  }
}

// export default RBSearchBar

function mapStateToProps (state, ownProps) {
  return {
    detailsData: state.BenefitDetailsReducer.detailsData,
    searchObj: state.BenefitDetailsReducer.search,
    isDisabled: ownProps.isDisabled
  }
}

const ConnectedRBSearchBar = connect(mapStateToProps, { searchDetails })(injectIntl(RBSearchBar))

const styles = {
  ...DropDownStyles,
  ...SearchBarStyles,
  button: {
    padding: 0,
    marginLeft: 6
  },
  searchIcon: {
    right: -12
  },
  tooltipIcon: {
    color: Colors.Palette.primaryTextColor
  }
}

export default withStyles(styles)(ConnectedRBSearchBar)



// WEBPACK FOOTER //
// ./src/controls/RBSearchBar.js